module.exports = { $type: 'atom' };



// WEBPACK FOOTER //
// .-path-utils/lib/support/materializedAtom.js